export const N34 = {
  "columns": 6,
  "rows": 1,
  "visual": {
    "id": 1,
    "type": "combo",
    "colorTheme": 'colorTheme1',
    "title": "Actual vs Target (% Performance)",
    "orientation": "vertical",
    "xAxis": "",
    "yAxis": "",
    "binding": {
      "data": {
        "series": [
          {
            "name": 'Sales',
            "value": 'Sales',
            "type": 'column'
          },
          {
            "name": 'Target',
            "value": 'Target',
            "type": 'column'
          },
          {
            "name": 'Performance %',
            "value": 'Performance',
            "type": 'line',
            "percent": true
          }
        ],
        "title": "Month",
        "endpoint": "N34",
        "parameters": [
          { "key": "FromMonth", "value": "2024" },
          { "key": "FromYear", "value": "1" },
          { "key": "ToMonth", "value": "2024" },
          { "key": "ToYear", "value": "1" },
          { "key": "ConfigTypeCode", "value": "" }
        ]
      },
      "context": {
        "point": {
          "onClick": {

          }
        }
      }
    }
  }
}